import React, { useContext, useState } from 'react'
import { Button, Form, Input, NotificationManagerContext, Spacer, Text, View } from 'oio-react'
import { ChromePicker } from 'react-color'
import { settingsDesignUrl } from 'src/components/utils/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'

const SettingsDesignColors = () => {
   const { organization } = useOrganization()
   const { updateOrganization, mutating } = useUpdateOrganization()
   const { showNotification } = useContext(NotificationManagerContext)
   const theme = useContext(ThemeContext)

   const [colorPickerVisibility, setColorPickerVisibility] = useState(false)
   const [highlightColor, setHighlightColor] = useState(
      organization.theme.highlightColor || 'black'
   )

   const handleSubmit = async () => {
      try {
         await updateOrganization({
            theme: { highlightColor }
         })

         showNotification({
            message: 'Changes saved successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (error) {
         showNotification({
            message: error.graphQLErrors.map(e => e.message).join(', ') || error.message,
            title: 'Error!',
            type: 'error'
         })
      }
   }

   return (
      <View>
         <ProtoReturnBar
            display="block[a-b] none[c-f]"
            returnLinkName="Design Settings"
            returnLinkTo={settingsDesignUrl}
         />
         <View display="flex" justifyContent="center">
            <View
               width="100%"
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <View paddingRight="30px[b-c] 50px[d-f]">
                     <ProtoHeadingBlock
                        title="Color Palette"
                        description="Customize the color swatch palette that will be used throughout your site."
                     />
                  </View>
                  <View flex="0 0 auto" paddingTop="30px">
                     <Button
                        onClick={handleSubmit}
                        type="submit"
                        name="Save Changes"
                        color={theme.protoSettingsHighlightBackgroundColor}
                        textColor={theme.protoSettingsHighlightForegroundColor}
                        textWeight="medium"
                        size="md"
                        textSize="0.9"
                        padding="25px"
                        mode={mutating ? 'loading' : 'normal'}
                     />
                  </View>
               </View>
               <Spacer size="3" />
               <View
                  float="left"
                  width="100%"
                  padding="20px"
                  marginTop="20px"
                  borderRadius="5px"
                  backgroundColor="#fff">
                  <View
                     float="left"
                     width="50px[a-b] 90px[c-f]"
                     height="50px[a-b] 90px[c-f]"
                     borderRadius="50%"
                     border="1px solid #ddd"
                     padding="5px"
                     boxShadow="5px 5px 30px rgba(0,0,0,0.1)"
                     style={{ overflow: 'hidden' }}>
                     <View
                        onClick={() => setColorPickerVisibility(true)}
                        float="left"
                        width="100%"
                        height="100%"
                        borderRadius="50%"
                        backgroundColor={highlightColor}
                     />
                  </View>
                  <View
                     float="left"
                     width="calc(100% - 60px)[a-b] calc(100% - 120px)[c-f]"
                     paddingLeft="25px[a-b] 40px[c-f]">
                     <Text size="2" weight="medium">
                        Highlight Color
                     </Text>
                     <Spacer size="1" />
                     <Text size="1.5" color="#444">
                        {'This is the primary color used for empasis troughout your site, including:  buttons, calls to action and accent text.'}
                     </Text>
                     <Spacer size="3" />
                     <View>
                        <Form
                           elementAppearance="plain"
                           elementBackgroundColor="#eee"
                           onSubmit={handleSubmit}>
                           <Input
                              onClick={() => setColorPickerVisibility(true)}
                              size="lg"
                              value={highlightColor}
                              readOnly
                           />
                        </Form>
                        {colorPickerVisibility && (
                           <View position="absolute">
                              <View
                                 onClick={() => setColorPickerVisibility(false)}
                                 position="fixed"
                                 top="0px"
                                 left="0px"
                                 right="0px"
                                 bottom="0px"
                              />
                              <ChromePicker
                                 color={highlightColor}
                                 onChange={color => setHighlightColor(color.hex)}
                              />
                           </View>
                        )}
                     </View>
                  </View>
               </View>
            </View>
         </View>
      </View>
   )
}

export default SettingsDesignColors
